<template>
    <b-container style="min-height: auto" class="article-dropdown-container"
                 v-bind:class="[{ busy: busy }, 'opacity-transition']">
        <pb-spinner v-if="busy"/>
        <b-row>
            <b-col>
                <b-form v-on:submit.prevent="search" class="my-2" ref="qrSearch">
                    <b-input-group>
                        <b-form-input id="search"
                                      name="search"
                                      placeholder="e.g. 2354220 Brass"
                                      v-model="searchTerm"
                                      v-validate="{ required: true, regex: /(^\d{6})(\d.*)*/ }"
                                      :state="validateState('search')"
                                      class="secondary search-input"/>
                        <b-input-group-append>
                            <b-input-group-text>
                                <span style="cursor:pointer;" @click="search()" class="icon-search"></span>
                            </b-input-group-text>
                        </b-input-group-append>
                        <b-form-invalid-feedback id="search-feedback" style="text-align: left">Please provide at least the first 6 digits of the article number.</b-form-invalid-feedback>
                    </b-input-group>

                </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="inner">

                <div v-if="searchResult && searchResult.length > 0">
                    <article-preview :key="key" v-for="(item,key) in searchResult"
                                     class="p-0"
                                     :article-details="item"
                                     @click="showArticle(item)"
                                     :thumbnail="item.webImage || item.image">
                    </article-preview>
                </div>
                <div v-else-if="errorMsg" class="text-left p-2">
                    {{errorMsg}}
                </div>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col class="text-left">
               - <router-link
                    :to="{ name: 'extended-search' }"
                    class="extended-search-link"
                    @click.native="$parent.forceHide && $parent.forceHide()">
                    Search
                </router-link>
            </b-col>
        </b-row>
        <b-modal ref="linkListModal" hide-footer centered size="md" title="Available in...">
            <template #modal-header="{ close }">
                <b-row class="align-items-center">
                    <b-col md="3">
                        <img v-if="selectedArticle" class="header-img"
                             :src="imageResource(selectedArticle.webImage, 100)" alt="image"/>
                    </b-col>
                    <b-col>
                        <h4 class="m-0 px-2">Available in...</h4>
                    </b-col>
                </b-row>

            </template>
            <ul>
                <li :key="key" v-for="(item,key) in linkList">
                    <router-link style="font-size: 14px;" @click.native="$refs.linkListModal.hide()" :to="item.target"
                                 class="d-block my-1">
                        {{item.name}}
                    </router-link>
                </li>
            </ul>
        </b-modal>
    </b-container>
</template>

<script>

    import { mapGetters } from "vuex";
    import ArticleApi from "../../../../../../../shared/_api/article";
    import ArticlePreview from "../../../../../components/dropdown-nav/ArticlePreview";

    export default {
        name: 'search-dropdown',
        components: {
            'article-preview': ArticlePreview
        },
        data() {
            return {
                searchTerm: null,
                searchResult: [],
                busy: false,
                errorMsg: null,
                selectedArticle: null
            };
        },
        methods: {
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            },
            showArticle(article) {
                this.selectedArticle = article;
                if (this.linkList.length === 1) {
                    this.$router.push(this.linkList[0].target);
                } else {
                    this.$refs.linkListModal.show();
                }
            },
            search() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.searchResult = [];
                        this.errorMsg = null;
                        if (this.searchTerm && this.searchTerm.length > 2) {
                            this.busy = true;
                            this.errorMsg = null;
                            ArticleApi.lookupArticle(this.searchTerm).then(res => {
                                if (!res || res.length === 0) {
                                    this.errorMsg = "No matches."
                                } else {
                                    this.searchResult = this.$_.orderBy(res, ['webImage', 'primaryDescription'], ['asc', 'asc']);
                                }

                               const articleIds = res ? res.map(article => article.id).join(';') : '';
                               const trackingMeta = this.searchTerm + (articleIds ? ';' + articleIds : '');

                               this.$tracker.trackEvent({
                                  label: 'search',
                                  meta: trackingMeta,
                                  type: 'SEARCH_REQUEST'
                               });

                            }).finally(() => {
                                this.busy = false;
                            });


                        }
                    }
                })
            },
        },
        computed: {
            ...mapGetters("account", ["canRead"]),
            canAccessExtendedSearch() {
                return this.canRead('MOOD_SEARCH');
            },
            linkList() {
                let articleLinks = [];
                if (this.selectedArticle) {
                    if (this.selectedArticle.publicArticle) {
                        articleLinks.push({
                            target: {
                                name: 'ar', params: {
                                    articleId: this.selectedArticle.id
                                }
                            },
                            name: 'Basic Shop'
                        })
                    }

                    this.selectedArticle.articleCategoryList.forEach(articleCategory => {
                        if (articleCategory.type === 'CUSTOMER_SHOP') {
                            articleLinks.push({
                                target: {
                                    name: 'ar',
                                    params: {articleId: this.selectedArticle.id, categoryId: articleCategory.id}
                                },
                                name: (articleCategory.webName || articleCategory.name)
                            })
                        } else {
                            articleLinks.push({
                                target: {
                                    name: 'customer',
                                    params: {id: articleCategory.id, searchString: this.searchTerm}
                                },
                                name: (articleCategory.webName || articleCategory.name)
                            })
                        }

                    });

                    if (articleLinks.length === 0) {
                        articleLinks.push({
                            target: {
                                name: 'basic',
                                params: {articleId: this.selectedArticle.id}
                            },
                            name: 'Open Details'
                        })
                    }
                }

                return articleLinks;
            },
        }, watch: {
            searchTerm: function (val) {
                if (!val || val.length === 0) {
                    this.searchResult = [];
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "~@shared/_assets/scss/constants";

    .header-img {
        max-height: 50px;
        flex: 1 0 0;
        width: 100%;
        height: 100%;
        margin: auto;
        -o-object-fit: contain;
        object-fit: contain;
    }

    .search-box {
        white-space: normal;
        width: 350px;

        .search-input {
            background-color: #F1F1F1;
            border: none;
        }

        .result-container {
            max-height: 400px;
            overflow-y: auto;
        }


    }

    .extended-search-link {
        color: #666;
        text-decoration: underline;

        &:hover {
            color: #333;
        }
    }

</style>
